let mixin = {
    data(){
        return{
            activeStep: 0,
            form : {
                isCompleted: false
            }
        }
    },
    mounted() {
        // Restaurar datos del paso desde formData al montar
        if (this.parentComputed && this.parentComputed.formData) {
            Object.keys(this.form).forEach(key => {
                if (this.parentComputed.formData[key] !== undefined) {
                    this.form[key] = this.parentComputed.formData[key];
                }
            });
            console.log('✅ [StepMixin] Datos restaurados en mounted:', this.form);
        }
    },
    watch: {
        $v: {
            handler: function (val) {
                if(!val.$invalid) {
                    this.$emit('can-continue', {value: true});
                    
                    console.log('🔄 [StepMixin] Validation passed, copying data...');
                    console.log('🔄 [StepMixin] Current form:', JSON.stringify(this.form, null, 2));
                    console.log('🔄 [StepMixin] Before merge - parent formData:', JSON.stringify(this.parentComputed.formData, null, 2));
                    
                    this.parentComputed.formData = {
                        ...this.parentComputed.formData,
                        ...this.form
                    }
                    
                    console.log('🔄 [StepMixin] After merge - parent formData:', JSON.stringify(this.parentComputed.formData, null, 2));
                }
            },
            deep: true
        },
    
    },
    computed: {
        parentComputed(){
            return this.$parent.$parent.$parent
        }
    },
    methods : {
        nextStep(){
            this.$v.$touch()
            if (this.$v.$invalid) {
                console.log('❌ [StepMixin] Validation failed');
            } else {
                console.log('✅ [StepMixin] nextStep called, validation passed');
                console.log('✅ [StepMixin] Current form data:', JSON.stringify(this.form, null, 2));
                // Guardar en localStorage antes de avanzar
                if (this.parentComputed.saveFormData) {
                    this.parentComputed.saveFormData();
                }
                this.parentComputed.nextStep()
                
            }
        },
        backStep(){
            // Guardar también al retroceder
            if (this.parentComputed.saveFormData) {
                this.parentComputed.saveFormData();
            }
            this.parentComputed.backStep()
        }
        
    }

}

export default mixin
